// extracted by mini-css-extract-plugin
module.exports = {"Layout":"layout_Layout__2G2ZC","LayoutContent":"layout_LayoutContent__3zhpZ","LayoutBg":"layout_LayoutBg__25cgR"};